const Config = {
    API: process.env.REACT_APP_API,
    API_SIGNUP: process.env.REACT_APP_API_SIGNUP,
    API_ROTATE: process.env.REACT_APP_API_ROTATE,
    API_PARTICIPATION: process.env.REACT_APP_API_PARTICIPATION,
    API_CONTENT: process.env.REACT_APP_API_CONTENT,
    API_PRESENT: process.env.REACT_APP_API_PRESENT,
    PWA: process.env.REACT_APP_PWA,
    MEETING_STATS: process.env.REACT_APP_MEETING_STATS,
    TEAMS_BY_PAGE: +process.env.REACT_APP_TEAMS_BY_PAGE || 50,
    UNASSIGNED_BY_PAGE: +process.env.REACT_APP_UNASSIGNED_BY_PAGE || 15,

    // AWS image upload
    AWS_IMAGE_UPLOAD: process.env.REACT_APP_AWS_IMAGE_UPLOAD,
    firebaseConfig: {
        apiKey: process.env.REACT_APP_API_KEY,
        authDomain: process.env.REACT_APP_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_DATABASE_URL,
        projectId: process.env.REACT_APP_PROJECT_ID,
        storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_APP_ID,
    },
}

export default Config
